import { api } from "../api";
import { ICancelledOrder } from "common/models/order/ICancelledOrder";
import { IFinishedOrder } from "common/models/order/IFinishedOrder";
import { IOrder } from "common/models/order/IOrder";
import { getFilterParameters } from "common/utils/helpers";

export interface IAdminOrdersQueryParams {
  date_from?: string;
  date_to?: string;
  query?: string;
  vehicle_category_id?: number[];
  vehicle_type_id?: number[];
}

function buildUrl(params: Undefinable<IAdminOrdersQueryParams>) {
  return `/admin/orders${getFilterParameters([
    { paramName: "vehicle_category_id[]", params: params?.vehicle_category_id },
    { paramName: "vehicle_type_id[]", params: params?.vehicle_type_id },
  ])}`;
}

function buildParams(
  params: Undefinable<IAdminOrdersQueryParams>,
  orderStatusId?: number
) {
  return {
    date_from: params?.date_from,
    date_to: params?.date_to,
    query: params?.query || undefined,
    order_status_id: orderStatusId,
  };
}

const adminOrdersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCancelledOrders: build.query<
      ICancelledOrder[],
      Undefinable<IAdminOrdersQueryParams>
    >({
      query(params) {
        return {
          url: buildUrl(params),
          method: "GET",
          params: buildParams(params, 9),
        };
      },
      transformResponse: (result: { orders: ICancelledOrder[] }) =>
        result.orders,
    }),
    getFinishedOrders: build.query<
      IFinishedOrder[],
      Undefinable<IAdminOrdersQueryParams>
    >({
      query(params) {
        return {
          url: buildUrl(params),
          method: "GET",
          params: buildParams(params, 8),
        };
      },
      transformResponse: (result: { orders: IFinishedOrder[] }) =>
        result.orders,
    }),
    getOrdersVisor: build.query<IOrder[], Undefinable<IAdminOrdersQueryParams>>({
      query(params) {
        return {
          url: buildUrl(params),
          method: "GET",
          params: buildParams(params),
        };
      },
      transformResponse: (result: { orders: IOrder[] }) => result.orders,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCancelledOrdersQuery,
  useGetFinishedOrdersQuery,
  useGetOrdersVisorQuery,
} = adminOrdersApi;
